import { Skeleton } from '@/components/ui/skeleton';
import { motion } from 'framer-motion';

interface ProfileStatsProps {
  postsCount?: number;
  followersCount?: number;
  followsCount?: number;
  isLoading?: boolean;
}

export function ProfileStats({
  postsCount,
  followersCount,
  followsCount,
  isLoading = false
}: ProfileStatsProps) {
  // Utility function to format numbers
  const formatNumber = (num: number | undefined | null): string => {
    if (num === undefined || num === null) return '0';
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num.toString();
  };

  if (isLoading) {
    return (
      <div className="grid w-full grid-cols-3 gap-2 sm:gap-4 text-center">
        <Skeleton className="h-14 sm:h-16 rounded-md" />
        <Skeleton className="h-14 sm:h-16 rounded-md" />
        <Skeleton className="h-14 sm:h-16 rounded-md" />
      </div>
    );
  }

  return (
    <div className="grid w-full grid-cols-3 gap-2 sm:gap-4 text-center">
      <motion.div
        initial={{ y: 5, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.1 }}
        className="rounded-md border bg-card/50 py-1.5 px-1 sm:p-2 hover:bg-card/60 transition-colors duration-200"
      >
        <p className="text-base sm:text-lg font-semibold">{formatNumber(postsCount)}</p>
        <p className="text-[10px] sm:text-xs text-muted-foreground">게시물</p>
      </motion.div>
      <motion.div
        initial={{ y: 5, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.2 }}
        className="rounded-md border bg-card/50 py-1.5 px-1 sm:p-2 hover:bg-card/60 transition-colors duration-200"
      >
        <p className="text-base sm:text-lg font-semibold">{formatNumber(followersCount)}</p>
        <p className="text-[10px] sm:text-xs text-muted-foreground">팔로워</p>
      </motion.div>
      <motion.div
        initial={{ y: 5, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        className="rounded-md border bg-card/50 py-1.5 px-1 sm:p-2 hover:bg-card/60 transition-colors duration-200"
      >
        <p className="text-base sm:text-lg font-semibold">{formatNumber(followsCount)}</p>
        <p className="text-[10px] sm:text-xs text-muted-foreground">팔로잉</p>
      </motion.div>
    </div>
  );
}